module.exports = __webpack_public_path__ + "img/header-weddingRingsFacetes@2x.0a00724.webp";